import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const HomePageFeaturedBox = ({ title, description, page, image }) => {
  return (
    <div className="box">
      {image && <img src={image} alt={`${title} logo`} />}

      <h3 className="is-size-4 has-text-primary">{title}</h3>
      <p>{description}</p>
      <Link to={`/featured/${page}/`} className="button is-link">
        Learn More
      </Link>
    </div>
  )
}

HomePageFeaturedBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  page: PropTypes.string.isRequired,
}

export default HomePageFeaturedBox
